export const TAB_CATEGORY = {
  TALENT_SEARCH: ['PREMIUM_CANDIDATE_SEARCH'],
  TALENT_POOL: { strict: false, any: ['PERM_TALENTPOOL_GET'] },
  JOB: { strict: false, any: ['PERM_JOB_GET'] },
  COMPANY_ADMIN: {
    strict: false,
    any: [
      'PERM_ADMIN_USER',
      'PERM_ADMIN_ROLE',
      'PERM_ADMIN_COMPANY',
      'PERM_ADMIN_COMPANY_JOB_LOCATION_MANAGE',
      'PERM_ADMIN_JOB_TEMPLATE',
      'PERM_DASHBOARD'
    ]
  },
  CLIENT_ADMIN: {
    strict: false,
    any: [
      'PERM_COMPANY_APPROVAL',
      'PERM_SET_ADS_ORDER',
      'PERM_ADMIN_UPLOAD_DATA',
      'PERM_ADMIN_SCHOOL_MANAGE',
      'PERM_ADMIN_STATUS_MANAGE',
      'PERM_ADMIN_MAJOR_MANAGE',
      'PERM_ADMIN_EXPORT_DATA'
    ]
  },
  REFERRAL: ['COMPUTED_COMPANY_HAS_REFERRAL', 'PERM_REFERRAL_MANAGERMENT'],
  CHAT_BOT: ['PERM_CHATBOT_MANAGEMENT', 'COMPUTED_COMPANY_HAS_CHAT_BOT'],
  CHART_REPORT: ['PERM_VIEW_CHART_REPORT', 'PREMIUM_EXPORT_DATA'],
  INTERVIEW: {
    strict: false,
    isMatchAnd: true,
    any: [
      ['PERM_HR_INTERVIEW_SCHEDULING', 'PREMIUM_INTERVIEW_SCHEDULING'],
      ['PREMIUM_INVITE_HM_REVIEW']
    ]
  },
  HR_REPORT: {
    strict: false, // any 中是否全部满足
    isMatchAnd: true, // any 的子数组中是否全部满足
    any: [
      ['PERM_VIEW_CHART_REPORT', 'PREMIUM_EXPORT_DATA'],
      ['PERM_VIEW_HR_REPORT', 'PREMIUM_HR_REPORT']
    ]
  }
}

export const HEADHUNTER_DISABLED_TABS = [
  TAB_CATEGORY.TALENT_POOL,
  TAB_CATEGORY.COMPANY_ADMIN,
  TAB_CATEGORY.CLIENT_ADMIN,
  TAB_CATEGORY.CHAT_BOT,
  TAB_CATEGORY.CHART_REPORT
]
